import React from 'react';
import Container from '../General/Container';
import Button from '../General/Button';

import {
  ContainerStyled,
  HeaderOvalStyled,
  TextStyled,
} from './styles/PasswordChangePanelContentStyled';
import { IpSearchBigIcon } from '../../images/consejos-bam';
import ipBrandsIcon from '../../images/consejos-bam/ip-brands.png';
import { redirectToExternalPage } from '../../helpers';

const PasswordChangePanelContent = () => {
  return (
    <>
      <HeaderOvalStyled />
      <Container background="transparent" boxShadow="none">
        <ContainerStyled>
          <IpSearchBigIcon />
          <TextStyled>
            En la <strong>barra de dirección</strong> ingresa uno de los
            siguiente números, dependiendo de tu router, usa puntos y sin
            espacios:
          </TextStyled>
          <img alt="Marcas" src={ipBrandsIcon} />
          <Button
            color="bubbleGum"
            maxWidth="100%"
            margin="50px 0px 0px 0px"
            click={() => redirectToExternalPage('https://www.wom.cl')}
          >
            IR A WOM.CL
          </Button>
        </ContainerStyled>
      </Container>
    </>
  );
};

export default PasswordChangePanelContent;
